import { AuthStatus } from "@kalyzee/kast-web-sdk";
import { Loading } from "@kalyzee/kast-web-sdk/web-components";
import { Outlet } from "react-router-dom";
import { SessionMode } from "../../contexts/appStore/hooks";

export interface PublicRouteProps {
  authStatus: AuthStatus;
  mode: SessionMode;
}

const PublicRoute = ({ authStatus, mode }: PublicRouteProps) => {
  return <Outlet />;
};

export default PublicRoute;
